import { isEmbarcacaoClasseEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoClasse,
  EmbarcacaoClasseState,
} from "@/modules/embarcacoes/embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

const CLASSE_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoClasse> = {
  select: (ficha) => ficha.classe,
  isEmpty: isEmbarcacaoClasseEmpty,
  secao: "a Classe",
};

interface UseEmbarcacaoClasseResult extends EmbarcacaoClasseState {
  reload: () => void;
}

/**
 * Consulta a Classe da embarcação pedida (AC4). Somente leitura: nenhuma
 * escrita é disparada na abertura nem no fechamento do modal.
 */
export function useEmbarcacaoClasse(id: string): UseEmbarcacaoClasseResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, CLASSE_QUERY);

  return { ...state, classe: data };
}
